import { UploaderAction, UploaderState } from './type';

export const initialState: UploaderState = {
  abort: [],
  failItem: [],
  fileList: [],
  isFinish: false,
  isMinimize: false,
  isReady: false,
  processingList: new Map(),
  remainingCount: 0,
  uploading: false,
  form: undefined,
};
export const reducer = (draft: UploaderState, action: UploaderAction) => {
  switch (action.type) {
    case 'setFileList':
      draft.fileList = action.payload;
      action.payload.forEach((item) => {
        draft.processingList.set(item.fileId, {
          fileId: item.fileId,
          name: item.name,
          progress: 0,
          size: item.size,
          status: item.status,
        });
      });
      draft.isReady = true;
      break;
    case 'retry':
      draft.failItem = [];
      draft.isFinish = false;
      draft.remainingCount = 0;
      draft.uploading = false;

      draft.fileList = action.payload;
      draft.processingList.clear();
      action.payload.forEach((item) => {
        draft.processingList.set(item.fileId, {
          fileId: item.fileId,
          name: item.name,
          progress: 0,
          size: item.size,
          status: item.status,
        });
      });
      draft.isReady = true;
      break;
    case 'setDeleteFile': {
      const index = draft.fileList.findIndex((item) => item.fileId === action.payload);

      draft.fileList.splice(index, 1);
      draft.processingList.delete(action.payload);
      break;
    }
    case 'setIsMinimize':
      draft.isMinimize = action.payload;
      break;
    case 'isUploading':
      draft.uploading = action.payload;
      break;
    case 'failItem':
      action.payload.ids.forEach((id: string) => {
        draft.failItem.push({ id, error: action.payload.error });
      });
      break;
    case 'isFinish':
      draft.isFinish = action.payload;
      draft.isReady = false;
      break;
    case 'setProgress':
      action.payload.ids.forEach((id) => {
        draft.processingList.set(id, {
          ...draft.processingList.get(id),
          progress: action.payload.progress,
          status: action.payload.status,
        });
      });
      break;
    case 'setRemainingCount':
      draft.remainingCount += action.payload;
      break;
    case 'setIsReady':
      draft.isReady = action.payload;
      draft.isFinish = false;
      break;
    case 'setAbort':
      draft.abort.push(action.payload);
      break;
    case 'editFile': {
      const index = draft.fileList.findIndex((x) => x.fileId === action.payload?.fileId);

      if (index !== -1) {
        draft.fileList[index] = action.payload;
      }

      break;
    }
    case 'reset':
      return initialState;
    default:
      break;
  }
};
